<!-- src/app/widget/pages/tour/tour-service-card/tour-service-card.component.html -->
<div
  class="tour-card cbw-tour-card"
  [class.selected]="isSelected()"
  [class.disabled]="isDisabled()"
  (click)="onClick()"
  (keydown.enter)="onClick()"
  (keydown.space)="onClick(); $event.preventDefault()"
  tabindex="0"
  role="button"
  [attr.aria-pressed]="isSelected()"
  [attr.aria-disabled]="isDisabled()"
>
  <div class="tour-card__image-wrapper cbw-tour-card-image-wrapper">
    @if (service().image_thumb_url) {
      <img
        class="tour-card__image cbw-tour-card-image"
        [src]="service().image_thumb_url"
        [alt]="service().name"
        loading="lazy"
      />
    } @else {
      <div class="tour-card__image tour-card__image--placeholder cbw-tour-card-image"></div>
    }
    @if (isSelected()) {
      <div class="tour-card__check-overlay" aria-hidden="true">
        <fa-icon [icon]="['fas', 'circle-check']" />
      </div>
    }
  </div>

  <div class="tour-card__body cbw-tour-card-body">
    <div class="tour-card__name cbw-tour-card-name">{{ service().name }}</div>
    @if (service().description) {
      <div class="tour-card__description cbw-tour-card-description">{{ service().description }}</div>
    }
    @if (hasUpcomingAbsences()) {
      <button
        type="button"
        class="tour-card__absence-badge cbw-tour-card-absence-badge"
        (click)="onBadgeClick($event)"
        (keydown.enter)="onBadgeClick($event)"
        (keydown.space)="onBadgeClick($event)"
      >
        <span class="tour-card__absence-dot" aria-hidden="true"></span>
        @if (upcomingAbsencesTemplate(); as tpl) {
          <span>{{ tpl | translation: templateContent.TEMPLATE_CONTENT: lang() }}</span>
        } @else {
          <span>{{ 'tour_widget.upcoming_absences_badge' | translate }}</span>
        }
      </button>
    }
  </div>

  <div class="tour-card__duration cbw-tour-card-duration">
    <div class="tour-card__duration-value">{{ durationMinutes() }}</div>
    <div class="tour-card__duration-unit">{{ 'tour_widget.minutes_short' | translate }}</div>
  </div>
</div>
